module.exports = "pegasus/assets/image-3-basic.png";